import { createContext, useContext, useMemo } from 'react';
import { useSearch } from '@/shared/hooks';
import useRolesStore from '@pkg/entities/library/roles/useStore';

export const RoleContext = createContext();
export const useRoleContext = () => useContext(RoleContext);

const RoleProvider = ({ children }) => {
  const roleMap = useRolesStore((state) => state.map);
  const roleList = useRolesStore((state) => state.list);
  const roleIndex = useRolesStore((state) => state.index);
  const updateRoleIndexes = useRolesStore((state) => state.setRoles);

  const searchRoles = useSearch({
    searchList: roleList,
    searchMap: roleMap,
    searchIndex: roleIndex,
  });

  const search = (searchTerm, validationFn) => {
    return searchRoles(searchTerm, validationFn);
  };

  /**
   * Updates the role index with the provided role list.
   *
   * @param {Array}
   */
  const context = useMemo(() => {
    return {
      search,
      roleList,
      roleMap,
      updateRoleIndexes,
    };
  }, [roleList, roleMap]);

  return (
    <RoleContext.Provider value={context}>{children}</RoleContext.Provider>
  );
};

export default RoleProvider;
